import { Maybe } from 'maybe-not';
import { IDict } from '../types/utility';
import SDKMessageBus from '../utility/message-bus';

interface IOverpanelOptions {
    fullWidth?: boolean;
}

export default function showOverpanelSetup(
    messageBus: SDKMessageBus,
    moduleId: string,
    capabilities: Set<string>
) {
    if (!capabilities.has('showOverpanel') || moduleId.includes('tectonOverpanel')) {
        return;
    }

    return function showOverpanel<T>(
        overpanelPath: string,
        params?: IDict<string>,
        options?: IDict<IOverpanelOptions>
    ): Promise<T> {
        const body = Maybe.maybe({
            moduleId,
            params,
            overpanelPath,
            options
        }).map(JSON.stringify);
        return messageBus.sendRequest<T>('showOverpanel', body).then(response => response.value);
    };
}
